import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { IconChat, IconCompare, IconKey } from './icons';
import { Reveal } from './Reveal';
import { Tilt3D } from './Tilt3D';
import { Button } from './Button';
import { scrollToLeadForm } from '../utils/scroll';
const STEPS = [{
  number: '01',
  icon: IconChat,
  title: 'how.1.title'
}, {
  number: '02',
  icon: IconCompare,
  title: 'how.2.title'
}, {
  number: '03',
  icon: IconKey,
  title: 'how.3.title'
}];
export function HowItWorks() {
  const {
    t
  } = useLanguage();
  return <section className="w-full bg-white" data-id="element-183" data-mp="qiv353w0tdy2">
      <div className="mx-auto w-full max-w-7xl px-4 py-16 sm:px-6 md:py-20" data-id="element-184" data-mp="cs81p3yvl9ya">
        <Reveal data-id="element-185" data-mp="cq5eerp3xux9">
          <h2 className="font-display text-2xl font-extrabold uppercase tracking-[0.16em] text-ink sm:text-3xl" data-id="element-186" data-mp="gtjrpalnvx70">
            {t('how.title')}
          </h2>
          <div aria-hidden="true" className="mt-3 h-[3px] w-12 bg-kred" data-id="element-187" data-mp="14hl10lqnzhnh" />
          <p className="mt-4 text-base text-body" data-id="element-188" data-mp="19aw7glrkdwev">{t('how.sub')}</p>
        </Reveal>
        <ol className="mt-10 grid grid-cols-1 gap-8 md:grid-cols-3" data-id="element-189" data-mp="2rl4rmtg1xmzo">
          {STEPS.map((step, index) => {
          const Icon = step.icon;
          return <li key={step.number} className="border-t border-camel/40 pt-5" data-id="element-190" data-mp="2mkqkddm9yh2p" data-mpi={index}>
                <Reveal delay={index * 0.08} data-id="element-191" data-mp="31csfylhbanwx">
                  <Tilt3D max={6} lift={10} data-id="element-192" data-mp="2wk8yvejf1and">
                    <div className="flex items-center gap-3" data-id="element-193" data-mp="2wjg2n7i323jh">
                    <span className="font-display text-2xl font-extrabold text-camelink" data-id="element-194" data-mp="3abe2ssttgp3i">
                      {step.number}
                    </span>
                    <Icon className="h-7 w-7 text-ink/45" data-id="element-195" data-mp="36cwuw72knal1" />
                  </div>
                    <h3 className="mt-4 font-display text-sm font-extrabold uppercase tracking-[0.16em] text-ink" data-id="element-196" data-mp="3k9k1z2o8nh4o">
                      {t(step.title)}
                    </h3>
                  </Tilt3D>
                </Reveal>
              </li>;
        })}
        </ol>

        {/* The last thing read before the form: it hands them straight into step 1. */}
        <Reveal delay={0.2} className="mt-10" data-id="element-197" data-mp="3l0igo5tthkq7">
          <Button type="button" onClick={scrollToLeadForm} className="sm:px-10" data-id="element-198" data-mp="3l1tjo3ffuog9">
            {t('how.cta')}
          </Button>
        </Reveal>
      </div>
    </section>;
}